'use strict';

import {ngDepModel} from './ngdepmodel.js';
import {periodicReportChecklistDataModel} from './periodicreportchecklistdatamodel.js';

export class periodicReportChecklistModel extends ngDepModel
{
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	getValue(name){
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		if(typeof(this.data_value[name]) !== 'undefined'){
			return this.data_value.getValue(name);
		}
		return null;
	}
	
	getConclusions(){
		return this.data_value.conclusion;
	}
	
	getConclusion(id){
		let name = 'value';
		if(arguments[1]){
			name = arguments[1];
		}
		return this.data_value.getConclusion(id, name);
	}
	
	beforeSetup(data){
		if(typeof(data.data_value) !== 'undefined'){
			data.data_value = new periodicReportChecklistDataModel(data.data_value, this._services.$filter, this._services.jsDataService);
			data.form_data = data.data_value;
		}
		else if(typeof(data.form_data) !== 'undefined'){
			data.data_value = new periodicReportChecklistDataModel(data.form_data, this._services.$filter, this._services.jsDataService);
			data.form_data = data.data_value;
		}
	}
	
	getComment(field){
		return this.data_value.fields.comment.getValue(field);
	}
	
	getQuestions(){
		return this.data_value.questions;
	}
	
	getQuestion(id){
		let name = 'value';
		if(arguments[1]){
			name = arguments[1];
		}
		return this.data_value.getQuestion(id, name);
	}
}
